import { leaderboardUsers } from "@/models/leaderboardUser.model";
import { brand } from "@/constants/brandVariables/brandVariables";
import { Box, Flex, Grid, Heading, Text } from "@radix-ui/themes";
import { Challenge } from "@/models/challenge.model";
import { FC, JSX } from "react";

import { formatGap } from "../../utils/formatRacingTime";
import LeaderboardItem from "../leaderboard/components/LeaderboardItem/LeaderboardItem";
import LeaderboardHero from "../leaderboard/components/LeaderboardHero/LeaderboardHero";
import SamsungHeader from "../shared/SamsungHeader";
import SamsungScreen from "../shared/SamsungScreen";

const formatEndedDate = (endDate?: Challenge["endDate"]): string => {
  if (!endDate?.seconds) return "";
  return new Date(endDate.seconds * 1000).toLocaleString(undefined, {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const EndscreenView: FC<{
  leaderboard: leaderboardUsers[];
  challenge?: Challenge | null;
}> = ({ leaderboard, challenge }): JSX.Element => {
  const champion = leaderboard[0];
  // Full standings on the right — including 1st place — even though the
  // champion is also highlighted as the hero on the left (matches the live
  // leaderboard, which keeps the leader in the list too).
  const standings = leaderboard.slice(0, brand.leaderboardLength);
  const championPoints = champion?.userChallengeData?.points;
  const endedDate = formatEndedDate(challenge?.endDate);

  return (
    <SamsungScreen>
      <SamsungHeader
          lines={["LATEST RESULTS"]}
          subtitle={
            (challenge?.name || endedDate) && (
              <Text size="3" style={{ color: "#9e9d9d" }}>
                {challenge?.name}
                {challenge?.name && endedDate ? " · " : ""}
                {endedDate ? `Ended ${endedDate}` : ""}
              </Text>
            )
          }
        />

        {leaderboard.length === 0 ? (
          <Flex align="center" justify="center" flexGrow="1">
            <Text size="5" color="gray">
              No results available.
            </Text>
          </Flex>
        ) : (
          <Grid
            className="sr-board__grid"
            columns="2fr 3fr"
            gap="4"
            width="100%"
          >
            <LeaderboardHero leader={champion} badge="CHAMPION" />

            <Flex direction="column" gap="2" minHeight="0">
              <Heading as="h2" size="5" style={{ color: "white" }} mb="1">
                FINAL STANDINGS
              </Heading>

              <Box className="sr-list">
                {standings.map((user, i) => (
                  <LeaderboardItem
                    key={`endscreen-${i}`}
                    item={user}
                    gap={formatGap(user.userChallengeData?.points, championPoints)}
                  />
                ))}
              </Box>
            </Flex>
          </Grid>
        )}
    </SamsungScreen>
  );
};

export default EndscreenView;
